import { useRef } from 'react';
import { useLocation } from 'react-router';
import { omit } from 'lodash';
import core from '@gin-betting/core';

const {
    services: { parse, stringify },
    hooks: { useDidUpdate },
} = core;

const RESOLVE_LIST_REQUEST_TIME = 50;

const useScrollToTop = () => {
    const timerIdRef = useRef<number | undefined>();
    const { pathname, search } = useLocation();
    const formattedSearch = stringify(omit(parse(search), 'page'));

    useDidUpdate(() => {
        timerIdRef.current = window.setTimeout(() => {
            window.scrollTo(0, 0);
        }, RESOLVE_LIST_REQUEST_TIME);

        return () => {
            clearTimeout(timerIdRef.current);
        };
    }, [pathname, formattedSearch]);
};

export default useScrollToTop;
